import httpRequestAdmin from "./httpRequest/httpRequestAdmin";

class CompanyCreditBalanceService {
  getCompanyCreditBalance(params) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + "company/credit/balance/details/from/admin", params);
  }
  updateCompanyCreditBalance(body) {
    return httpRequestAdmin.put(process.env.REACT_APP_BACKEND_API_URL + "company/credit/balance/update/from/admin", body);
  }
}

export default new CompanyCreditBalanceService();
